import React from 'react';

import { BaseIconProps } from './';

export const UserTie = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(19.720624,0,0,19.720624,-16399.217,-27123.036)"
    d="m 869.207,1406.234 -5.113,20.473 -3.423,-14.547 3.423,-5.99 h -10.268 l 3.422,5.99 -3.422,14.547 -5.113,-20.473 c -7.627,0.363 -13.713,6.6 -13.713,14.311 v 4.45 c 0,2.835 2.3,5.134 5.134,5.134 h 37.651 c 2.835,0 5.134,-2.3 5.134,-5.134 v -4.45 c 0,-7.712 -6.086,-13.948 -13.712,-14.311 z m -10.247,-3.487 c 7.562,0 13.691,-6.13 13.691,-13.691 0,-7.563 -6.129,-13.692 -13.691,-13.692 -7.563,0 -13.692,6.13 -13.692,13.692 0,7.562 6.13,13.69 13.692,13.69 z"
    fill={fill}
  />
);
